import { render } from "./CaseSettingsPopUp.vue?vue&type=template&id=7cc70f84&scoped=true&ts=true"
import script from "./CaseSettingsPopUp.vue?vue&type=script&lang=ts"
export * from "./CaseSettingsPopUp.vue?vue&type=script&lang=ts"

import "./CaseSettingsPopUp.vue?vue&type=style&index=0&id=7cc70f84&scoped=true&lang=sass"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cc70f84"]])

export default __exports__